module.exports = __webpack_public_path__ + "img/screenshot-staff-list.06ba99cb.png";